export default __webpack_public_path__ + "static/media/bigbasket.27a07c8b.png";